'use strict';

import angular from 'angular';
import moment from 'moment';

/**
 * @ngdoc controller
 * @name observatoireApp.controller:AutorisationsExploitationController
 * @description
 * # AutorisationsExploitationController
 * Contrôleur pour la gestion des autorisations d'exploitation
 */
angular.module('observatoireApp')
  .controller('AutorisationsExploitationController', ['$scope', '$http', '$location', '$stateParams', 'AutorisationsExploitationService', 'MetaService',
    /**
     * Contrôleur pour la gestion des autorisations d'exploitation pétrolière
     */
    function ($scope, $http, $location, $stateParams, AutorisationsExploitationService, MetaService) {
      
      // Initialiser les métadonnées de la page
      MetaService.setAll({
        title: 'Autorisations d\'exploitation pétrolière - Observatoire Tchadien',
        description: 'Liste des autorisations d\'exploitation pétrolière en vigueur au Tchad avec leurs statuts, dates et informations géographiques.',
        keywords: 'autorisations exploitation, pétrole, tchad, gisement, bloc pétrolier, carte interactive'
      })
      
      // Données d'initialisation pour la vue
      $scope.autorisations = [];
      $scope.filtres = {
        typeAutorisation: '',
        statut: '',
        societe: '',
        recherche: ''
      };
      $scope.triActuel = { colonne: 'dateDerniereModification', direction: 'desc' };
      $scope.isLoading = true;
      
      // Options pour le tableau des autorisations
      $scope.optionsTableau = {
        limites: [10, 25, 50, 100],
        limite: 10,
        page: 1
      };
      
      // Ajout de Math dans le scope pour les expressions dans le HTML
      $scope.Math = window.Math;
      
      /**
       * Charge les autorisations d'exploitation depuis l'API
       */
      $scope.chargerAutorisations = function() {
        $scope.isLoading = true;
        
        $http.get('/api/autorisations-exploitation')
          .then(function(response) {
            let autorisations = response.data;
            
            // Conversion des dates si nécessaire
            autorisations.forEach(function(autorisation) {
              autorisation.datePermis = $scope.convertirDate(autorisation.datePermis);
              autorisation.dateDemande = $scope.convertirDate(autorisation.dateDemande);
              autorisation.dateDebutExploitation = $scope.convertirDate(autorisation.dateDebutExploitation);
              autorisation.dateExpirationPrevue = $scope.convertirDate(autorisation.dateExpirationPrevue);
              autorisation.dateExpirationProlongee = $scope.convertirDate(autorisation.dateExpirationProlongee);
              autorisation.dateResiliation = $scope.convertirDate(autorisation.dateResiliation);
              autorisation.dateDerniereModification = $scope.convertirDate(autorisation.dateDerniereModification);
            });
            
            $scope.autorisations = autorisations;
            $scope.isLoading = false;
            
            // Logging pour débogage
            console.log('Données brutes reçues de l\'API:', JSON.stringify(autorisations, null, 2));
            
            // Initialiser les filtres avec les valeurs disponibles
            $scope.typesAutorisations = [...new Set(autorisations.map(a => a.typeAutorisation))].filter(Boolean);
            $scope.statuts = [...new Set(autorisations.map(a => a.statut))].filter(Boolean);
            $scope.societes = [...new Set(autorisations.map(a => a.denomination))].filter(Boolean).sort();
            
            // Configurer la carte si des coordonnées sont disponibles
            $scope.initialiserCarte();
          })
          .catch(function(error) {
            console.error('Erreur lors du chargement des autorisations:', error);
            $scope.isLoading = false;
            
            // Créer des données de test en cas d'erreur
            $scope.autorisations = [
              {
                id: 1,
                denomination: 'ESSO EXPLORATION & PRODUCTION CHAD',
                gisement: 'Moundouli',
                blocPetrolier: 'Bloc H',
                statut: 'En vigueur',
                datePermis: new Date(2017, 6, 1),
                dateExpirationPrevue: new Date(2037, 5, 30),
                typeAutorisation: 'Autorisation Exclusive d\'Exploitation d\'hydrocarbures liquides et gazeux'
              },
              {
                id: 2,
                denomination: 'CNPCIC',
                gisement: 'Mimo',
                blocPetrolier: 'Bloc H',
                statut: 'En vigueur',
                datePermis: new Date(2013, 2, 15),
                dateExpirationPrevue: new Date(2033, 2, 14),
                typeAutorisation: 'Autorisation Exclusive d\'Exploitation d\'hydrocarbures liquides et gazeux'
              }
            ];
            
            $scope.isLoading = false;
            $scope.typesAutorisations = [...new Set($scope.autorisations.map(a => a.typeAutorisation))].filter(Boolean);
            $scope.statuts = [...new Set($scope.autorisations.map(a => a.statut))].filter(Boolean);
            $scope.initialiserCarte();
          });
      };
      
      /**
       * Filtre la liste des autorisations en fonction des critères
       * @returns {Array} Liste filtrée des autorisations
       */
      $scope.autorisationsFiltrees = function() {
        let filtered = $scope.autorisations;
        
        // Filtre par type d'autorisation
        if ($scope.filtres.typeAutorisation) {
          filtered = filtered.filter(a => a.typeAutorisation === $scope.filtres.typeAutorisation);
        }
        
        // Filtre par statut
        if ($scope.filtres.statut) {
          filtered = filtered.filter(a => a.statut === $scope.filtres.statut);
        }
        
        // Filtre par société
        if ($scope.filtres.societe) {
          filtered = filtered.filter(a => a.denomination === $scope.filtres.societe);
        }
        
        // Filtre par texte de recherche
        if ($scope.filtres.recherche) {
          const recherche = $scope.filtres.recherche.toLowerCase();
          filtered = filtered.filter(a => 
            (a.denomination && a.denomination.toLowerCase().includes(recherche)) ||
            (a.reference && a.reference.toLowerCase().includes(recherche)) ||
            (a.referenceContrat && a.referenceContrat.toLowerCase().includes(recherche)) ||
            (a.projet && a.projet.toLowerCase().includes(recherche)) ||
            (a.blocPetrolier && a.blocPetrolier.toLowerCase().includes(recherche)) ||
            (a.gisement && a.gisement.toLowerCase().includes(recherche))
          );
        }
        
        return filtered;
      };
      
      /**
       * Tri les autorisations selon la colonne sélectionnée
       * @param {string} colonne Nom de la colonne à trier
       */
      $scope.trierPar = function(colonne) {
        // Si on clique sur la même colonne, on inverse la direction
        if ($scope.triActuel.colonne === colonne) {
          $scope.triActuel.direction = $scope.triActuel.direction === 'asc' ? 'desc' : 'asc';
        } else {
          // Sinon, on trie par la nouvelle colonne en ordre ascendant
          $scope.triActuel.colonne = colonne;
          $scope.triActuel.direction = 'asc';
        }
      };
      
      /**
       * Fonction de tri pour le tableau
       * @param {Object} autorisation Autorisation à trier
       * @returns {*} Valeur utilisée pour le tri
       */
      $scope.ordreTri = function(autorisation) {
        const colonne = $scope.triActuel.colonne;
        let valeur = autorisation[colonne];
        
        // Cas particulier pour les dates (s'assurer qu'elles sont comparables)
        if (colonne.startsWith('date') && valeur) {
          return valeur instanceof Date ? valeur.getTime() : valeur;
        }
        
        return valeur;
      };
      
      /**
       * Configuration et initialisation de la carte Leaflet
       */
      $scope.initialiserCarte = function() {
        // Vérifier si Leaflet est disponible dans l'environnement global
        if (typeof L === 'undefined') {
          console.error('Leaflet n\'est pas disponible (L non défini)');
          return;
        }
        
        // Vérifier si l'élément existe dans le DOM
        const mapContainer = document.getElementById('exploitation-map');
        if (!mapContainer) {
          console.error('Container de carte non trouvé (id: exploitation-map)');
          setTimeout($scope.initialiserCarte, 500); // Réessayer après un délai
          return;
        }

        // Coordonnées du centre du Tchad
        const centerLat = 12.1348;
        const centerLng = 15.0557;
        const defaultZoom = 5;

        // Initialiser la carte
        const map = L.map('exploitation-map', {
          center: [centerLat, centerLng],
          zoom: defaultZoom,
          scrollWheelZoom: false
        });

        // Ajouter les couches de fond (tile layers)
        const osmLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; OpenStreetMap contributors',
          maxZoom: 18
        }).addTo(map);

        const satelliteLayer = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
          attribution: 'Source: Esri, DigitalGlobe, GeoEye, Earthstar Geographics',
          maxZoom: 18
        });

        // Grouper les couches de fond
        const baseMaps = {
          "OpenStreetMap": osmLayer,
          "Satellite": satelliteLayer
        };

        // Créer un groupe de marqueurs avec clustering
        const markers = L.markerClusterGroup();

        // Uniquement à titre d'exemple - dans une vraie implémentation,
        // il faudrait obtenir les coordonnées réelles de chaque gisement
        const coordsExemples = [
          { lat: 11.5, lng: 15.7 },  // Coordonnées fictives des gisements
          { lat: 12.3, lng: 16.2 },
          { lat: 10.9, lng: 15.1 },
          { lat: 11.8, lng: 14.5 },
          { lat: 12.7, lng: 15.5 }
        ];
        
        // Ajouter des marqueurs pour chaque autorisation
        $scope.autorisations.forEach((autorisation, index) => {
          if (index < coordsExemples.length) {
            const position = coordsExemples[index];
            const statut = autorisation.statut || 'Non défini';
            
            // Définir la couleur du marqueur selon le statut
            let markerColor = '#7F7F7F'; // Gris par défaut
            if (statut.includes('vigueur')) {
              markerColor = '#5cb85c'; // Vert
            } else if (statut.includes('expiré')) {
              markerColor = '#d9534f'; // Rouge
            }
            
            // Créer une icône personnalisée pour le marqueur
            const markerIcon = L.divIcon({
              className: 'custom-marker',
              html: `<div style="background-color: ${markerColor}; width: 20px; height: 20px; border-radius: 50%; border: 2px solid white;"></div>`,
              iconSize: [20, 20],
              iconAnchor: [10, 10]
            });
            
            // Créer le marqueur avec popup
            const marker = L.marker([position.lat, position.lng], {
              icon: markerIcon,
              title: autorisation.denomination
            });
            
            // Contenu du popup
            const popupContent = `
              <div class="marker-popup">
                <h4>${autorisation.gisement || 'Gisement'}</h4>
                <p><strong>Société:</strong> ${autorisation.denomination}</p>
                <p><strong>Statut:</strong> <span class="status-${statut.toLowerCase().replace(/ /g, '-')}">${statut}</span></p>
                <p><strong>Date de permis:</strong> ${$scope.formatterDate(autorisation.datePermis)}</p>
                <p><a href="#/autorisations-exploitation/${autorisation.id}" class="btn btn-sm btn-primary">Voir détails</a></p>
              </div>
            `;
            
            marker.bindPopup(popupContent);
            markers.addLayer(marker);
          }
        });
        
        // Ajouter le groupe de marqueurs à la carte
        map.addLayer(markers);
        
        // Ajouter le contrôle des couches
        L.control.layers(baseMaps, {
          "Autorisations": markers
        }).addTo(map);
        
        // Ajouter une légende
        const legend = L.control({position: 'bottomright'});
        legend.onAdd = function(map) {
          const div = L.DomUtil.create('div', 'map-legend');
          div.innerHTML = `
            <h4>Légende</h4>
            <div class="legend-item">
              <span class="legend-color active-color"></span> En vigueur
            </div>
            <div class="legend-item">
              <span class="legend-color expired-color"></span> Expiré
            </div>
            <div class="legend-item">
              <span class="legend-color default-color"></span> Autre
            </div>
          `;
          return div;
        };
        legend.addTo(map);
        
        // Stocker la référence de la carte dans $scope pour y accéder plus tard
        $scope.map = map;
        
        console.log('Carte Leaflet initialisée avec succès');
      };
      
      // Charger les autorisations au démarrage
      $scope.chargerAutorisations();
      
      /**
       * Calcule le nombre de pages pour la pagination
       * @returns {number} Nombre de pages
       */
      $scope.nombrePages = function() {
        return Math.ceil($scope.autorisationsFiltrees().length / $scope.optionsTableau.limite);
      };
      
      /**
       * Génère un tableau contenant les numéros de page pour la pagination avec des ellipses
       * @returns {Array<number|string>} Tableau des numéros de page ou ellipses
       */
      $scope.getPages = function() {
        const currentPage = $scope.optionsTableau.page;
        const totalPages = $scope.nombrePages();
        const maxVisiblePages = 5; // Nombre max de pages visibles à la fois
        const pages = [];
        
        // Protection contre les valeurs invalides
        if (isNaN(totalPages) || totalPages <= 0) return pages;
        
        // Cas simple : moins de pages que le maximum visible
        if (totalPages <= maxVisiblePages) {
          for (let i = 1; i <= totalPages; i++) {
            pages.push(i);
          }
          return pages;
        }
        
        // Cas avec ellipses
        // Toujours inclure la première page
        pages.push(1);
        
        // Calculer la plage de pages autour de la page courante
        const leftBound = Math.max(2, currentPage - Math.floor((maxVisiblePages - 3) / 2));
        const rightBound = Math.min(totalPages - 1, leftBound + maxVisiblePages - 3 - 1);
        
        // Ajouter l'ellipse avant si nécessaire
        if (leftBound > 2) {
          pages.push('...');
        }
        
        // Ajouter les pages centrales
        for (let i = leftBound; i <= rightBound; i++) {
          pages.push(i);
        }
        
        // Ajouter l'ellipse après si nécessaire
        if (rightBound < totalPages - 1) {
          pages.push('...');
        }
        
        // Toujours inclure la dernière page
        if (totalPages > 1) {
          pages.push(totalPages);
        }
        
        return pages;
      };
      
      /**
       * Gère le changement du nombre d'éléments par page
       * Reset la page courante à 1 pour éviter les problèmes de pagination
       */
      $scope.changerElementsParPage = function() {
        $scope.optionsTableau.page = 1;
      };
      
      /**
       * Retourne les autorisations pour la page actuelle
       * @returns {Array} Autorisations pour la page actuelle
       */
      $scope.autorisationsPage = function() {
        const autorisationsFiltrees = $scope.autorisationsFiltrees();
        const debut = ($scope.optionsTableau.page - 1) * $scope.optionsTableau.limite;
        const fin = debut + $scope.optionsTableau.limite;
        
        return autorisationsFiltrees.slice(debut, fin);
      };
      
      /**
       * Convertit une valeur de date en objet Date
       * @param {*} dateVal Valeur de la date (à convertir)
       * @returns {Date|null} Objet Date ou null si impossible à convertir
       */
      $scope.convertirDate = function(dateVal) {
        if (!dateVal) return null;
        
        // Si dateVal est déjà un objet Date, le retourner directement
        if (dateVal instanceof Date) {
          return dateVal;
        }
        
        // Gérer le cas où dateVal est un tableau [année, mois, jour, ...]
        if (Array.isArray(dateVal)) {
          // Dans les tableaux, le mois est 1-indexed, mais dans Date() il est 0-indexed
          const moisIndex = dateVal[1] - 1; 
          return new Date(dateVal[0], moisIndex, dateVal[2], dateVal[3] || 0, dateVal[4] || 0);
        }
        
        // S'assurer que dateVal est une chaîne de caractères pour les formats textuels
        const dateString = typeof dateVal === 'string' ? dateVal : String(dateVal);
        
        // Format: yyyy-MM-dd
        if (typeof dateString === 'string') {
          const simpleDateMatch = dateString.match(/(\d{4})-(\d{2})-(\d{2})/);
          if (simpleDateMatch) {
            return new Date(simpleDateMatch[1], simpleDateMatch[2]-1, simpleDateMatch[3]);
          }
        }
        
        // Format: yyyy-MM-dd HH:mm:ss
        if (typeof dateString === 'string') {
          const match = dateString.match(/(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})/);
          if (match) {
            return new Date(match[1], match[2]-1, match[3], match[4], match[5], match[6]);
          }
        }
        
        // Essayer le constructeur Date standard en dernier recours
        const date = new Date(dateString);
        
        // Vérifier si la date est valide (pas NaN)
        if (!isNaN(date.getTime())) {
          return date;
        }
        
        return null;
      };
      
      /**
       * Formatte une date pour l'affichage
       * @param {Date|string|Array} date Date à formater
       * @returns {string} Date formatée
       */
      $scope.formatterDate = function(date) {
        if (!date) return 'N/A';
        
        if (date instanceof Date) {
          return date.toLocaleDateString('fr-FR');
        }
        
        if (Array.isArray(date)) {
          // Si c'est un tableau [année, mois, jour], formater manuellement
          return `${date[2]}/${date[1]}/${date[0]}`;
        }
        
        try {
          return new Date(date).toLocaleDateString('fr-FR');
        } catch (e) {
          return date.toString();
        }
      };
    }])
  .name;
